import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { get_productos_admin, deleteProducto } from '../../../redux/actions/productos';
import AdminCategoryList from '../AdminCategoryList';
import AdminProductCard from '../AdminProductCard';
import NewProductModal from '../NewProductModal';
import styles from './AdminProductList.module.css';
import useFuzzySearch from '../../../hooks/useFuzzySearch';
import cards from '../../../styles/shared/ProductCards.module.css';


const AdminProductList = ({ productos, get_productos_admin, deleteProducto, searchTerm, selectedProductId, searchField }) => {
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [showNuevoProducto, setShowNuevoProducto] = useState(false);
    const [openProductId, setOpenProductId] = useState(null);
    const fuzzySearch = useFuzzySearch(productos, searchField);

    useEffect(() => {
        get_productos_admin();
    }, [get_productos_admin]);

    useEffect(() => {
        if (productos) {
            setProductosFiltrados(productos);
        }
    }, [productos]);

    useEffect(() => {
        if (productos && selectedProductId) {
            setProductosFiltrados(productos.filter(producto => producto && producto.id === selectedProductId));
        } else if (productos && searchTerm) {
            setProductosFiltrados(fuzzySearch(searchTerm));
        } else {
            setProductosFiltrados(productos || []);
        }
    }, [productos, searchTerm, selectedProductId, searchField, fuzzySearch]);

    const handleCategoryChange = useCallback((categoria, seccion = null) => {
        if (categoria === "Todo") {
            setProductosFiltrados(productos); // Show all products
        } else {
            const filteredProducts = productos.filter(producto =>
                producto.categoria === categoria && (!seccion || producto.seccion === seccion)
            );
            setProductosFiltrados(filteredProducts);
        }
    }, [productos]);



    const handleNuevoClick = () => {
        setShowNuevoProducto(true);
    };

    const handleCloseNuevoProducto = () => {
        setShowNuevoProducto(false);
    };

    const handleProductAdded = (newProduct) => {
        get_productos_admin(); // Refresh the product list
    };

    const handleCardClick = (productId) => {
        setOpenProductId(productId);
    };

    const handleCloseProductModal = () => {
        setOpenProductId(null);
    };


    return (
        <main className={styles.page}>
            <div className={styles.container}>
                <AdminCategoryList 
                    mostrarPorCategoria={handleCategoryChange}
                    onNuevoClick={handleNuevoClick}
                    productos={productos}
                />
                <div className={styles.cardContainerWrapper}>
                    <div className={cards.cardContainer}>
                        {productosFiltrados.map(producto => (
                            <AdminProductCard
                                key={producto.id}
                                producto={producto}
                                isOpen={openProductId === producto.id}
                                onOpen={() => handleCardClick(producto.id)}
                                onClose={handleCloseProductModal}
                                deleteProducto={deleteProducto}
                            />
                        ))}
                    </div>
                </div>
            </div>
            {showNuevoProducto && (
                <NewProductModal 
                    onClose={handleCloseNuevoProducto}
                    onProductAdded={handleProductAdded}
                />
            )}
        </main>
    );
};


const mapStateToProps = state => ({
    productos: state.Productos.productos,
    searchTerm: state.Productos.searchTerm,
    selectedProductId: state.Productos.selectedProductId,
    searchField: state.Productos.searchField,
});

export default connect(mapStateToProps, {
    get_productos_admin,
    deleteProducto 
})(AdminProductList);